import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export type DeliveryStatus = 'PENDING' | 'SHIPPED' | 'IN_TRANSIT' | 'DELIVERED' | 'FAILED';

export interface ShippingAddress {
  name: string;
  street: string;
  city: string;
  state?: string;
  zip: string;
  country: string;
}

export interface PhysicalBenefit {
  id: string;
  creatorProfileId: string;
  membershipId: string;
  tierId?: string;
  benefitName: string;
  description?: string;
  shippingAddress?: ShippingAddress;
  trackingNumber?: string;
  carrier?: string;
  deliveryStatus: DeliveryStatus;
  confirmationNote?: string;
  createdAt: string;
  updatedAt: string;
  membership?: {
    id: string;
    patron?: {
      id: string;
      username: string;
      email: string;
    };
  };
  tier?: {
    id: string;
    name: string;
  };
}

export interface CreatePhysicalBenefitPayload {
  membershipId: string;
  tierId?: string;
  benefitName: string;
  description?: string;
  shippingAddress?: ShippingAddress;
}

export interface UpdatePhysicalBenefitPayload {
  trackingNumber?: string;
  carrier?: string;
  deliveryStatus?: DeliveryStatus;
  confirmationNote?: string;
}

export const physicalBenefitsService = {
  async getPhysicalBenefits(creatorId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/physical-benefits/creator/${creatorId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { physicalBenefits: PhysicalBenefit[] };
  },

  async getPhysicalBenefit(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/physical-benefits/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { physicalBenefit: PhysicalBenefit };
  },

  async createPhysicalBenefit(payload: CreatePhysicalBenefitPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/physical-benefits`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string; physicalBenefit: PhysicalBenefit };
  },

  async updatePhysicalBenefit(id: string, payload: UpdatePhysicalBenefitPayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_BASE_URL}/api/physical-benefits/${id}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string; physicalBenefit: PhysicalBenefit };
  },

  async deletePhysicalBenefit(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/physical-benefits/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },
};


